// 全局配置，不同环境配置值可以不一样
export const environment = 'production';
export const apiBase = 'https://api.mihoyo.com/bh3-event-kiana_galgame/intro';
